/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from "react";
import ReactSelect from "react-select";
import ChakraReactSelect from "./chakra-react-select";
var Select = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ChakraReactSelect, props, /*#__PURE__*/React.createElement(ReactSelect, {
    ref: ref
  }));
});
export default Select;